import React from 'react';
import * as S from './style';

export interface Props extends React.LabelHTMLAttributes<HTMLLabelElement> {
  htmlFor?: string;
  contents?: string | number | React.ReactNode;
  required?: boolean;
  color?: string;
  fontStyle?: string;
  isUnderLine?: boolean;
  wordBreak?: boolean;
  cursor?: string;
  onClick?: (e: React.MouseEvent<HTMLLabelElement, MouseEvent>) => void;
}

const Label: React.FC<Props> = ({
  htmlFor,
  contents,
  required = false,
  ...props
}) => {
  if (typeof contents === 'string') {
    return contents !== '0' ? (
      <S.StyledLabel htmlFor={htmlFor} required={required} {...props}>
        {contents}
      </S.StyledLabel>
    ) : null;
  } else {
    return (
      <S.StyledLabel htmlFor={htmlFor} required={required} {...props}>
        {contents}
      </S.StyledLabel>
    );
  }
};

export default Label;
